export const getNumber = (value?: string | null): number => (isNumeric(value) ? Number(value) : 0);

export const isNumeric = (value?: string | null): boolean => !isNaN(Number(value));

export const numberFormat = (value: number, locale: string = 'it-IT', options?: object): string =>
  new Intl.NumberFormat(locale, options).format(value);

type NumericString = null | undefined | number | string;
export const compareNumberAndNumericString = (a: NumericString, b: NumericString): boolean => {
  if (a === null || a === undefined || b === null || b === undefined) {
    return false;
  }

  return Number(a) === Number(b);
};
